import { DateTime } from 'luxon';
import { StorePickupFieldsFragment } from '../../../graphql';
import { HoursFields } from '../../types';
import { getStoreOpenStatus } from '../getStoreOpenStatus';
import { isStoreConnected } from '../isStoreConnected';

export const isAsapAvailable = (
	store: HoursFields & StorePickupFieldsFragment,
	now: DateTime
): boolean => {
	const status = getStoreOpenStatus(store, now);
	const connected = isStoreConnected(store);

	return status === 'OPEN' && connected;
};
